// hooks/useGoogleOneTap.js
'use client';

import { useEffect } from 'react';
import { signIn, useSession } from 'next-auth/react';

let googleOneTapInitialized = false;
const GOOGLE_AUTH_SCRIPT_LOADED_EVENT = 'mpweb_google_auth_script_loaded';

export default function useGoogleOneTap(isEnabled = true) {
  const {status} = useSession();

  useEffect(() => {
    const handleCredentialResponse = (response) => {
      signIn('google', {
        credential: response.credential,
      });
    };

    const initializeGoogleOneTap = () => {
      if (typeof window === 'undefined' || !isEnabled || status !== 'unauthenticated') {
        return;
      }

      const googleAccounts = window.google?.accounts?.id;
      if (!googleAccounts) {
        return;
      }

      if (!googleOneTapInitialized) {
        googleAccounts.initialize({
          client_id: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID,
          callback: handleCredentialResponse,
        });
        googleOneTapInitialized = true;
      }

      googleAccounts.prompt();
    };

    const cancelGoogleOneTap = () => {
      window.google?.accounts?.id?.cancel?.();
    };

    if (!isEnabled || status !== 'unauthenticated') {
      cancelGoogleOneTap();
      if (!isEnabled) {
        googleOneTapInitialized = false;
      }
    } else {
      initializeGoogleOneTap();
    }

    window.addEventListener(GOOGLE_AUTH_SCRIPT_LOADED_EVENT, initializeGoogleOneTap);

    return () => {
      window.removeEventListener(GOOGLE_AUTH_SCRIPT_LOADED_EVENT, initializeGoogleOneTap);
    };
  }, [isEnabled, status]);
}